(function(){
    'use strict';

    angular
    .module('appback')
    .controller('CentrosController', CentrosController)
 
    CentrosController.$inject = ["CentroService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function CentrosController(CentroService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;

		var today = new Date();
		var currentMonth = ('0' + (today.getMonth() + 1)).slice(-2); // Mes actual en formato 'MM'
		var currentYear = today.getFullYear().toString() 
		vm.selectedMonth = currentMonth;
		vm.selectedYear = currentYear;
		vm.facturacion_total = "";
		
        vm.getInfoCentro = function(centro_id){
        	CentroService.getInfoCentro(centro_id,function(data){
				console.log("data info centro", data)
        		vm.infoCentro = data;
        		vm.ctXCompra = document.getElementById('myChartFactCentro');
        		vm.ctXCompra.height = 350;
        		vm.ctXCompra = vm.ctXCompra.getContext('2d');
				vm.chartAnual = new Chart(vm.ctXCompra, {
				    type: 'bar',
				    data: {
				        labels: data.facturas.fechas,
				        datasets: [{
				            label: 'Facturación',
				            data: data.facturas.importe,
				            borderWidth: 1
				        }]
				    },
				    options: {
				        scales: {
				            yAxes: [{
				                ticks: {
				                    beginAtZero: true
				                }
				            }]
				        }
				    }
				});
        	});

        }

		vm.getFacturacionPrevista = function(centro_id){
			CentroService.getFacturacionPrevista(centro_id,vm.selectedMonth, vm.selectedYear, function(data){
				if(data.code>0){
					vm.facturacion_total = data.facturacion_total
					vm.facturacion_peticiones = data.facturacion_peticiones
					vm.facturacion_material = data.facturacion_material
				}
			});
		}
        
    }
  
})();